module.exports = __webpack_public_path__ + "static/media/logo_ilmi.edf81bb5.png";